import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const OrdenVentaPerfectaHorizontalBar = ({ selectedIndustries = [] }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getPerfectOrderByEmployees, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getPerfectOrderByEmployees() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const labels = excelData.labels.length > 0
    ? excelData.labels
    : ['Hasta 10', 'Entre 11 a 50', 'Entre 51 y 100', 'Entre 101 y 250', 'entre 251 y 1,000', 'Más de 1,000'];

  const data2022 = excelData.data2022.length > 0 ? excelData.data2022 : [0, 84, 90, 92, 90, 91];
  const data2023 = excelData.data2023.length > 0 ? excelData.data2023 : [97, 98, 83, 93, 93, 91];
  const data2024 = excelData.data2024.length > 0 ? excelData.data2024 : [97, 97, 93, 94, 95, 93];

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: data2022,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2024',
        data: data2023,
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2025',
        data: data2024,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    layout: {
      padding: {
        top: 20,
        bottom: 40,
      }},
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { position: 'top' },
      datalabels: {
        color: '#000',
        anchor: 'end',
        align: 'right',
        offset: 4,
        formatter: (value) => (value !== null ? `${value}%` : ''),
        font: { weight: 'bold', size: 9 },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 115,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rango de Empleados',
        },
      },
    },
  };

  const infoContent = {
    formula: 'Orden de Venta Perfecta (%) = (Órdenes entregadas completas, a tiempo y sin errores / Total de órdenes) × 100',
    description: 'Mide la proporción de órdenes de ventas entregadas a tiempo y completas.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

};

export default OrdenVentaPerfectaHorizontalBar;
